import { useState } from 'react';
// utils
import { useDrag, useProvider } from '../Provider';

const useDragDropUploader = () => {
    const {
        handleUpload,
        blockerFormat,
        isFetching,
        formatFile,
        setBlockerFormat,
        error,
        setError,
        downloadErrorLink,
        resetStore,
    } = useProvider();

    const { handleDragLeave, handlerDragEnter, isDragging, handleResetDrag } = useDrag();

    const [files, setFiles] = useState<any>([]);

    const handleCloseIcon = (): void => {
        handleResetDrag();
        resetStore();
    };

    const resetErrorsWhenHaveFormatError = () => {
        setError(null);
        handleResetDrag();
    };

    return {
        handleUpload,
        blockerFormat,
        isFetching,
        formatFile,
        handleDragLeave,
        isDragging,
        files,
        setFiles,
        handleCloseIcon,
        setBlockerFormat,
        resetErrorsWhenHaveFormatError,
        handlerDragEnter,
        error,
        downloadErrorLink,
    };
};

export default useDragDropUploader;
